module.exports = __webpack_public_path__ + "img/Advanced Search - Gray.b2eb8c3c.png";